import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import { Heading, Container, Text } from "@chakra-ui/react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const InfoPage = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title

  return (
    <Layout location={location} title={siteTitle} container>
      <SEO title="Betingelser" />
      <Container marginTop="20">
        <Heading size="xl" marginBottom="5">
          Leasing
        </Heading>

        <Text>
          Leasing fremkommer som en fast månedspris. Det tilkommer imidlertid et
          etableringsgebyr til Grenke Bank ved oppstart kr 650.
        </Text>
        <Text size="lg" marginTop="5">
          Når du velger å lease elsykkel krever vår leasingpartner at sykkelen
          er forsikret. Vi har valgt å installere Bikefinder (Sporingsenhet som
          monteres på sykkel)på alle elsykler som leases. Bikefinder er
          inkludert i den månedlige leasingkostnaden du betaler,men forsikringen
          må du som bruker av sykkel tegne selv. Med Bikefinder får du tegnet
          markedets beste elsykkelforsikring. Før sykkel leveres ut må bruker av
          elsykkelen aktivere sin Bikefinder med valgt elsykkelforsikring fra
          Tryg. Bekreftelse på forsikring formidles til salgsstedet og da er
          elsykkel klar til utlevering
        </Text>

        <Text size="lg" marginTop="5">
          Bedriften du jobber i leaser elsykkelen og legger inn et lønnstrekk
          tilsvarende leasingkostnad pr mnd inkl mva. Leasingperiode 3 år. Årlig
          service inkludert, totalt 3 servicer. (inkl. software oppdatering).
          Den ansatte er ansvarlig for vedlikehold og reparasjon utover årlig
          service. Den ansatte kan etter endt leasingperiode kjøpe ut sykkelen
          for beløp tilsvarende 3 måneders leie. Leverandøren tar kontakt med en
          enkelte leasing tager 4 mnd før leasingavtalen går ut for tilbud om
          utkjøp. Ved utkjøp underveis vil resterende av leasingperioden
          faktureres + utkjøp (3 mnd leie). Leasingavtalen vil bli mellom
          leasingselskapet (Grenke Bank AG Branch Norway) og selskapet den
          ansatte jobber for. Navnet til den enkelte ansatte i firmaet vil
          fremkomme på kontrakten. Leasing kontrakten signeres av den som har
          prokura i selskapet.
        </Text>

        <Heading marginTop="10" marginBottom="5" size="xl">
          Kjøp
        </Heading>

        <Text>
          Sykkel og utstyr faktureres fratrukket rabatt inkl mva . Ansatte står
          fritt til å forsikre sykkel, men tilbud om Bikefinder og forsikring
          gjelder også ved kjøp. Årlig service, totalt 3 servicer. (inkl.
          software oppdatering) Den ansatte er ansvarlig for vedlikehold og
          reparasjon utover årlig service.
        </Text>

        <Heading size="sm" marginTop="5" marginBottom="2">
          Garanti
        </Heading>

        <Text>
          Sykkel må følge beskrevet service og vedlikeholds regime for at
          garantier skal gjelde. Det er 5 års fabrikkgaranti på motor, batteri
          og elektronikk.{" "}
        </Text>
        <Text>
          Sykler kan bestilles fra nettbutikk med utlevering fra våre 2 butikker
          eller tilkjørt hos den respektive bedrift.
        </Text>
      </Container>
    </Layout>
  )
}

InfoPage.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
}

export default InfoPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
